import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
// import { removeHTML } from '../../utils'
// import { ProgressBar } from '../ProgressBar'
// import flecha_s from "../HeaderCourses/assets/flecha-s.png";
import logoSence from '../../assets/LOGO-SENCE-SIN-FONDO.png'

export const CourseCard = ({ item = null, moodle, lang }) => {
  /*   const enddate = new Date(item.startdate).toDateString() */
  /*   const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }; */
  const theme = useTheme();
  const navigation = useNavigate();
  const backgroundref = React.useRef(null);

  React.useEffect(() => {
    if (item.overviewfiles.length > 0) {
      let imgurl = moodle.getCourseImg(item);
      backgroundref.current.style.backgroundImage = `url(${imgurl})`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigation = (percentage) => {
    /* navigation(`/detailcourse/${percentage}/${item.id}`); */
    // localStorage.setItem("courseProgress", JSON.stringify(percentage));
    moodle.setCurrentModules(null);
    navigation(`/detailcourse/${item.id}`);
  };

  return (
    <div
      className="my-5 rounded-[14px] border-[1px] border-slate-200/30 shadow-md hover:shadow-2xl transition-shadow duration-300 max-w-[320px]"
      style={{
        boxShadow: theme.mode === "dark" ? "#f5f5f5" : "#18232d", // TODO: Pasar a Theme Context
      }}
    >
      <div
        className={`flex flex-col justify-between h-full rounded-[14px] overflow-hidden`}
        style={{
          backgroundColor: theme.mode === "dark" ? "#060036" : "#EDEDED", // TODO: Pasar a Theme Context

        }}
      >
        {/* Imagen */}
        <div
          ref={backgroundref}
          className=" w-full bg-gray-300 bg-cover bg-center"
          style={{aspectRatio: "3/2"}}
          alt="imagen del curso"
        />
        {item && item.idnumber.includes("sence") &&<div className="relative">
        <img src={logoSence} alt="logo-sence" className="w-28 h-auto absolute right-0 bottom-0 drop-shadow-lg m-2 " /> 

        </div>}

        <section className="flex flex-col px-4 py-2 min-h-[200px]">
          {/* Nombre */}
          <h2
            className="text-lg font-outfit font-medium px-4 text-left mt-4 laptop:text-2xl line-clamp-3"
            style={{color: theme.mode === "light" ? "#16232c" : "#fff"}}
            title={item.fullname}
          >
            {item.fullname}
          </h2>

          {/* Progressgdshfgkjfho */}
          <div className="flex flex-col flex-grow px-4 py-3">
            {/* <progress
              id="file"
              max="100"
              value={item?.progress?.toFixed(0) || 0}
              className="w-full h-2 rounded-full overflow-hidden appearance-none"
            >
              {item?.progress?.toFixed(0) || 0}%
            </progress> */}
            <p
              className="mt-2 text-lg font-lato font-medium text-left"
              style={{color: theme.mode === "light" ? "#16232c" : "#fff"}} // TODO: Cambiar Styles por Colors
            >
              {item?.progress?.toFixed(0) || 0}% Completado
            </p>
          </div>

          {/* Botón de ingreso */}
          <div className="px-4 pb-4 flex justify-center mt-auto">
            <button
              onClick={handleNavigation}
              type="button"
              style={{ backgroundColor: theme.mode === "light" ? theme.colors.primary_dark : theme.colors.primary_light }}
              className="flex items-center justify-center w-[280px] h-[42px] gap-2 py-2 px-4 rounded-xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            >
              <span
                className="font-semibold text-3xl"
                style={{ color: theme.colors.TextColorCardBtn }}
              >
                {lang["Home"].course_btn}
              </span>
            </button>
          </div>
        </section>
        {/* Nombre */}
      </div>
    </div>
  );
};
